import axios from "axios";

const apiUrl = process.env.REACT_APP_APIBASE_URL;
// const apiUrl = "http://localhost:4000/api";


// const [cookieExpired, setcookieExpired] = useState(false)
const api = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

async function fetchFreshAccessToken(){
  return await api.get('/refresh')
}

api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 403 &&  !originalRequest._retry) {
        originalRequest._retry = true;
        console.error("Session expired. Ferching new token...");
        await fetchFreshAccessToken();
        return api(originalRequest)
    } else if ( error.response?.status === 403 || error.response?.status === 401 ){
        window.location.href = '/'
    } else{
        // Reject the error with a proper Error object
        const rejectionError = new Error(
          error.response?.data?.error || error.response?.data || "An error occurred"
        );
        throw rejectionError;
    }
  }
);

export default api;
export const openApi = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});
 